// const getCitationMarkers = (mode, styles, ace) => {
//     let txt;
//     var className;
//     let typ;
//     if (mode === "image") {
//         txt = /(Fig|Figure)\.*~*\\ref{(.*?)}/gi;
//         className = styles.reference;
//     } else if (mode === "Table") {
//         txt = /Table\.*~*\\ref{(.*?)}/gi;
//         className = styles.table_cit;
//     } else if (mode === "equation") {
//         txt = /(equation|eq|eqs)*\.*~*\(*(\\eqref|\\ref){(.*?)}\)*/gi;
//         className = styles.equ_cit;
//     } else {
//         txt = /\\cite{(.*?)}/gi;
//         className = styles.citation;
//     }

import { logDOM } from "@testing-library/react";

//     if (ace.current.editor) {
//         ace.current.editor.$search.$options = {
//             needle: txt,
//             wrap: true,
//             caseSensitive: false,
//             wholeWord: false,
//             regExp: true,
//             preventScroll: true, // do not change selection
//         };
//     }
//     var res = ace.current.editor.$search.findAll(ace.current.editor.session);
//     var allMarkers = [];
//     for (var r of res) {
//         var text = ace.current.editor.session.getTextRange(r);
//         if (/(Fig|Figure)\.*~*\\ref{/i.test(text)) {
//             typ = text.match(/(Fig|Figure)\.*~*\\ref{/i);
//             text = text
//                 .replace(/(Fig|Figure)\.*~*\\ref{/i, "")
//                 .replace(/\}\)*/, "");
//         } else if (/(equation|eq|eqs)*\.*~*\(*(\\ref|\\eqref){/i.test(text)) {
//             typ = text.match(/(equation|eq|eqs)*\.*~*\(*(\\ref|\\eqref){/i);
//             text = text
//                 .replace(/(equation|eq|eqs)*\.*~*\(*(\\ref|\\eqref){/i, "")
//                 .replace(/\}\)*/, "");
//         } else if (/Table\.*~*\\ref{/i.test(text)) {
//             typ = text.match(/Table\.*~*\\ref{/i);
//             text = text.replace(/Table\.*~*\\ref{/i, "").replace(/\}\)*/, "");
//         } else if (/\\cite{/i.test(text)) {
//             typ = text.match(/\\cite{/i);
//             text = text.replace(/\\cite{/i, "").replace(/\}\)*/, "");
//         } else {
//         }
//         var tend = text.length;
//         var commaSeparated = text.split(",");
//         var st = typ[0].length;

//         // console.log(r);
//         var end = 0;
//         for (var i = 0; i < commaSeparated.length; i++) {
//             end += commaSeparated[i].length;
//             allMarkers.push({
//                 startRow: r.start.row,
//                 startCol: r.start.column + st,
//                 endRow: r.end.row,
//                 endCol: r.end.column - (tend - (end - 1) - i),
//                 className: className,
//                 type: "text",
//                 text: commaSeparated[i].trim(),
//             });
//             st = st + commaSeparated[i].length + 1;
//         }
//     }
//     return allMarkers;
// };

// const getCitationMarkers = (styles, ace) => {
//     if (!ace.current.editor) return [];

//     const editor = ace.current.editor;
//     // Combined regex for all citation types
//     const combinedRegex = /(Fig|Figure)\.*~*\\ref{(.*?)}|(Table)\.*~*\\ref{(.*?)}|((equation|eq|eqs)*\.*~*\(*(\\eqref|\\ref){(.*?)}\)*)|~\\cite{(.*?)}/gi;

//     // editor.$search.$options = {
//     //     needle: combinedRegex,
//     //     wrap: true,
//     //     caseSensitive: false,
//     //     wholeWord: false,
//     //     regExp: true,
//     //     preventScroll: true,
//     // };
//     let lines = ace.current.editor.session.getDocument().getAllLines(); //array of lines 
//     let fullText = lines.join("\n"); //array to whole tex 
//     //console.log(fullText);
//     let results = [];
//     let match;
//     const allMarkers = [];

//     while ((match = combinedRegex.exec(fullText)) !== null) {
//         const startIndex = match.index;
//         const endIndex = startIndex + match[0].length;

//         const startPos = indexToPos(startIndex, lines);
//         const endPos = indexToPos(endIndex, lines);

//         results.push({
//             start: startPos,
//             end: endPos
//         });
//     } 

//     function indexToPos(index, lines) {
//         let row = 0;
//         let remaining = index;

//         while (row < lines.length && remaining > lines[row].length) {
//             remaining -= (lines[row].length + 1); // +1 for newline
//             row++;
//         }
//         return {
//             row: row,
//             column: remaining
//         };
//     }

//     for (let r of results) {
//         let text = editor.session.getTextRange(r);
//         let typeMatch, className;

//         if (/(Fig|Figure)\.*~*\\ref{/i.test(text)) {
//             typeMatch = text.match(/(Fig|Figure)\.*~*\\ref{/i);
//             className = styles.reference;
//             text = text.replace(/(Fig|Figure)\.*~*\\ref{/i, "").replace(/\}\)*/, "");
//         } else if (/Table\.*~*\\ref{/i.test(text)) {
//             typeMatch = text.match(/Table\.*~*\\ref{/i);
//             className = styles.table_cit;
//             text = text.replace(/Table\.*~*\\ref{/i, "").replace(/\}\)*/, "");
//         } else if (/(equation|eq|eqs)*\.*~*\(*(\\eqref|\\ref){/i.test(text)) {
//             typeMatch = text.match(/(equation|eq|eqs)*\.*~*\(*(\\eqref|\\ref){/i);
//             className = styles.equ_cit;
//             text = text.replace(/(equation|eq|eqs)*\.*~*\(*(\\eqref|\\ref){/i, "").replace(/\}\)*/, "");
//         } else if (/\\cite{/i.test(text)) {
//             typeMatch = text.match(/\\cite{/i);
//             className = styles.citation;
//             text = text.replace(/\\cite{/i, "").replace(/\}\)*/, "");
//         }

//         const tend = text.length;
//         const commaSeparated = text.split(",");
//         let st = typeMatch[0].length;
//         let end = 0;

//         for (let i = 0; i < commaSeparated.length; i++) {
//             end += commaSeparated[i].length;
//             allMarkers.push({
//                 startRow: r.start.row,
//                 startCol: r.start.column + st,
//                 endRow: r.end.row,
//                 endCol: r.end.column - (tend - (end - 1) - i),
//                 className,
//                 type: "text",
//                 text: commaSeparated[i].trim(),
//             });
//             st = st + commaSeparated[i].length + 1;
//         }
//     }

//     return allMarkers;
// };


// const getInlineEqnMarkers = (ace, styles) => {
//     ace.current.editor.$search.$options = {
//         needle: "\\$(.*?)\\$",
//         wrap: true,
//         caseSensitive: false,
//         wholeWord: false,
//         regExp: true,
//         preventScroll: true, 
//     };
//     var res = ace.current.editor.$search.findAll(ace.current.editor.session);
//     var allMarkers = [];
//     for (var r of res) {
//         var text = ace.current.editor.session.getTextRange(r);
//         text = text.replace(/\$/g, "");
//         allMarkers.push({
//             startRow: r.start.row,
//             startCol: r.start.column + 1,
//             endRow: r.end.row,
//             endCol: r.end.column - 1,
//             className: styles.inline_equation,
//             type: "text",
//             text: text,
//         });
//     }
//     return allMarkers;
// };

// const getEqnMarkers = (ace, styles) => {
//     var maxLines = 10;
//     ace.current.editor.$search.$options = {
//         needle: /\\begin\{eq.*/g,
//         wrap: true,
//         caseSensitive: false,
//         wholeWord: false,
//         regExp: true,
//         preventScroll: true, // do not change selection
//     };
//     var res = ace.current.editor.$search.findAll(ace.current.editor.session);
//     var allMarkers = [];
//     for (var r of res) {
//         var found = false;
//         var text = ace.current.editor.session.getTextRange(r);
//         //ace.current.editor.session.getTextRange({start:{row:5}, end:{row:5}})
//         for (var i = 1; i < maxLines; i++) {
//             var curText = ace.current.editor.session.getLine(r.start.row + i);
//             text += "\r\n" + curText;
//             if (curText.indexOf("\\end") === 0) {
//                 found = true;
//                 break;
//             }
//         }
//         if (found) {
//             allMarkers.push({
//                 startRow: r.start.row,
//                 startCol: r.start.column,
//                 endRow: r.start.row + i,
//                 endCol: curText.length,
//                 className: styles.equation,
//                 type: "text",
//                 text: text,
//             });
//         }
//     }
//     return allMarkers;
// };

// export {
//     getCitationMarkers,
//     getInlineEqnMarkers,
//     getEqnMarkers
// }

const getCitationMarkers = (styles, ace) => {
    if (!ace.current.editor) return [];

    const editor = ace.current.editor;
    const session = editor.session;
    const fullText = session.getValue();
    const allMarkers = [];
    const isCommented = (text, index) => {
        let lineStart = index;
        while (lineStart > 0 && text[lineStart - 1] !== '\n') lineStart--;
        const linePrefix = text.slice(lineStart, index);
        for (let i = 0; i < linePrefix.length; i++) {
            if (linePrefix[i] === '%' && (i === 0 || linePrefix[i - 1] !== '\\')) {
                return true;
            }
        }
        return false;
    };
    const figRegex = /(Fig\.?|Figure\.?)~*\\ref\{([^}]*)\}/gi;
    let match;

    while ((match = figRegex.exec(fullText)) !== null) {
        if (isCommented(fullText, match.index)) continue;

        const prefix = match[1];  
        const labelContent = match[2]; 
        const prefixLength = prefix.length + match[0].indexOf('{') - prefix.length + 1;
        // Position where label starts (after \ref{)
        const labelStartIndex = match.index + match[0].indexOf('{') + 1;

        // Handle comma-separated labels
        const labels = labelContent.split(',');
        let offset = 0;

        labels.forEach(label => {
            const trimmedLabel = label.trim();
            const startIndex = labelStartIndex + offset + (label.length - label.trimStart().length);
            const startPos = getPosition(fullText, startIndex);
            const endPos = getPosition(fullText, startIndex + trimmedLabel.length);

            allMarkers.push({
                startRow: startPos.row,
                startCol: startPos.col,
                endRow: endPos.row,
                endCol: endPos.col,
                className: styles.reference,
                type: "text",
                text: trimmedLabel
            });

            offset += label.length + 1;
        });
    }
    const tableRegex = /Table\.?~*\\ref\{([^}]*)\}/gi;

    while ((match = tableRegex.exec(fullText)) !== null) {
        if (isCommented(fullText, match.index)) continue;

        const labelContent = match[1];
        const labelStartIndex = match.index + match[0].indexOf('{') + 1;

        const labels = labelContent.split(',');
        let offset = 0;

        labels.forEach(label => {
            const trimmedLabel = label.trim();
            const startIndex = labelStartIndex + offset + (label.length - label.trimStart().length);
            const startPos = getPosition(fullText, startIndex);
            const endPos = getPosition(fullText, startIndex + trimmedLabel.length);

            allMarkers.push({
                startRow: startPos.row,
                startCol: startPos.col,
                endRow: endPos.row,
                endCol: endPos.col,
                className: styles.table_cit,
                type: "text",
                text: trimmedLabel
            });

            offset += label.length + 1;
        });
    }

    // ==================== 3. Equation references: eq/eqs/equation~\eqref{} or \ref{} ====================
    const eqRegex = /((?:equation|eq|eqs)\.?~*)?\(*\\(eqref|ref)\{([^}]*)\}\)*/gi;

    while ((match = eqRegex.exec(fullText)) !== null) {
        if (isCommented(fullText, match.index)) continue;

        const labelContent = match[3];
        const labelStartIndex = match.index + match[0].indexOf('{') + 1;

        const labels = labelContent.split(',');
        let offset = 0;

        labels.forEach(label => {
            const trimmedLabel = label.trim();
            const startIndex = labelStartIndex + offset + (label.length - label.trimStart().length);
            const startPos = getPosition(fullText, startIndex);
            const endPos = getPosition(fullText, startIndex + trimmedLabel.length);

            allMarkers.push({
                startRow: startPos.row,
                startCol: startPos.col,
                endRow: endPos.row,
                endCol: endPos.col,
                className: styles.equ_cit,
                type: "text",
                text: trimmedLabel
            });

            offset += label.length + 1;
        });
    }

    // ==================== 4. Citations: \cite{} ====================
    const citeRegex = /~?\\cite\{([^}]*)\}/gi;

    while ((match = citeRegex.exec(fullText)) !== null) {
        if (isCommented(fullText, match.index)) continue;

        const labelContent = match[1];
        const labelStartIndex = match.index + match[0].indexOf('{') + 1;

        const labels = labelContent.split(',');
        let offset = 0;

        labels.forEach(label => {
            const trimmedLabel = label.trim();
            const startIndex = labelStartIndex + offset + (label.length - label.trimStart().length);
            const startPos = getPosition(fullText, startIndex);
            const endPos = getPosition(fullText, startIndex + trimmedLabel.length);

            allMarkers.push({
                startRow: startPos.row,
                startCol: startPos.col,
                endRow: endPos.row,
                endCol: endPos.col,
                className: styles.citation,
                type: "text",
                text: trimmedLabel
            });

            offset += label.length + 1;
        });
    }

    return allMarkers;
};


const getInlineEqnMarkers = (ace, styles) => {
    if (!ace.current.editor) return [];

    const session = ace.current.editor.session;
    const fullText = session.getValue();
    const allMarkers = [];

    // Match inline math $...$ but not $$...$$
    // Use negative lookahead/lookbehind to avoid matching $$
    const inlineRegex = /(?<!\$)\$(?!\$)(.*?)(?<!\$)\$(?!\$)/gs;
    let match;

    while ((match = inlineRegex.exec(fullText)) !== null) {
        const fullMatch = match[0];      // $...$
        const innerText = match[1];      // content without $
        // Skip empty
        if (!innerText.trim()) continue;
        // Skip if commented
        let lineStart = match.index;
        while (lineStart > 0 && fullText[lineStart - 1] !== '\n') lineStart--;
        const linePrefix = fullText.slice(lineStart, match.index);
        const isCommented = linePrefix.includes('%') &&
            !linePrefix.slice(0, linePrefix.indexOf('%')).includes('\\%');
        if (isCommented) continue;

        // +1 to skip opening $, -1 to skip closing $
        const contentStartIndex = match.index + 1;
        const contentEndIndex = match.index + fullMatch.length - 1;

        const startPos = getPosition(fullText, contentStartIndex);
        const endPos = getPosition(fullText, contentEndIndex);

        allMarkers.push({
            startRow: startPos.row,
            startCol: startPos.col,
            endRow: endPos.row,
            endCol: endPos.col,
            className: styles.inline_equation,
            type: "text",
            text: innerText
        });
    }

    return allMarkers;
};


const getEqnMarkers = (ace, styles) => {
    if (!ace.current.editor) return [];

    const session = ace.current.editor.session;
    const fullText = session.getValue();
    const allMarkers = [];
    // ==================== HELPER: Check if index is commented ====================
    const isCommented = (text, index) => {
        let lineStart = index;
        while (lineStart > 0 && text[lineStart - 1] !== '\n') {
            lineStart--;
        }
        // linePrefix is a STRING not array - use string loop
        const linePrefix = text.slice(lineStart, index);
        for (let i = 0; i < linePrefix.length; i++) {
            if (linePrefix[i] === '%' && (i === 0 || linePrefix[i - 1] !== '\\')) {
                return true;
            }
        }
        return false;
    };
    const eqnRegex = /\\begin\{(eq[^}]*)\}([\s\S]*?)\\end\{\1\}/g;
    let match;

    while ((match = eqnRegex.exec(fullText)) !== null) {
        const fullMatch = match[0];
        const matchIndex = match.index;

        if (isCommented(fullText, matchIndex)) continue;

        const startPos = getPosition(fullText, matchIndex);
        const endPos = getPosition(fullText, matchIndex + fullMatch.length);

        allMarkers.push({
            startRow: startPos.row,
            startCol: startPos.col,
            endRow: endPos.row,
            endCol: endPos.col,
            className: styles.equation,
            type: "text",
            text: fullMatch
        });
    }

    return allMarkers;
};

function getPosition(text, index){
    let row = 0;
    let col = 0;
    for (let i = 0; i < index; i++) {
        if (text[i] === '\n') {
            row++;
            col = 0;
        } else {
            col++;
        }
    }
    return { row, col };
}

export {
    getCitationMarkers,
    getInlineEqnMarkers,
    getEqnMarkers
};